<template>
  <div class="exam_contain">
    <div class="exam_select_flex">
      <div class="exam_select_box">
        <div class="exam_select_item">
          <span style="margin-left:30px">批次：</span>
          <el-select v-model="filtrate.appraisalId" placeholder="请选择批次">
            <el-option
              v-for="(item,index) in batchList"
              :key="index"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="exam_select_item">
          <span style="margin-left:30px">科目：</span>
          <el-select v-model="filtrate.subject" placeholder="请选择科目" :disabled="!filtrate.appraisalId">
            <el-option
              v-for="(item,index) in subjectList"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="exam_select_item">
          <span>考试场地：</span>
          <el-select v-model="filtrate.addressId" placeholder="请选择状态">
            <el-option
              v-for="(item,index) in addressItem"
              :key="index"
              :label="item.examAddressName"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="exam_select_box">
        <div class="exam_select_item">
          <span>考试日期：</span>
          <el-select v-model="filtrate.day" multiple collapse-tags placeholder="全部考试日期" >
            <el-option
              v-for="(item,index) in examDayList"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="exam_select_item">
          <span>考试时间：</span>
          <el-select 
            v-model="filtrate.period"
            multiple
            collapse-tags
            placeholder="全部考试时间" 
            :disabled="!(filtrate.day.length>1 || filtrate.day[0])"
          >
            <el-option
              v-for="(item,index) in examTimeList"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="exam_button_box">
      <el-button type="primary" @click="getPageList()">查询</el-button>
      <el-dropdown>
        <el-button type="primary">
          导出
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <div @click="exportExcel()">导出考试场次预约信息EXCEL</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 表格 -->
    <div class="table_wrapper">
      <div class="table_content">
        <el-table 
          border 
          :data="examarr" 
          max-height="650"
          stripe
        >
          <el-table-column prop="serial" width="60" label="序号"></el-table-column>
          <el-table-column prop="addressName" label="考试场地"></el-table-column>
          <el-table-column prop="subjectText" width="80" label="科目"></el-table-column>
          <el-table-column prop="examDate" width="180" label="考试时间"></el-table-column>
          <el-table-column prop="occupationLevelCodeText" width="130" label="等级"></el-table-column>
          <el-table-column prop="maxNumber" width="120" label="计划考试人数"></el-table-column>
          <el-table-column prop="alreadyNumber" width="120" label="已预约人数"></el-table-column>
          <el-table-column prop="remainNumber" width="120" label="剩余可预约人数"></el-table-column>
          <el-table-column prop="latestSignUpTimeText" label="报名截止时间"></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="page_footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[12, 24, 48, 360]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listCount">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {downloadBlob} from '@/utils/util.js'
export default {
  data() {
    return {
      filtrate: {
        addressId: '',
        appraisalId: '',
        subject: '',
        status: '',
        day: [],
        period: [],
      },
      page: 1,
      limit: 12,
      examarr: [],
      listCount: 0,
      batchList: [],
      subjectList: [],
      examDateList: [],
      examDayList: [],  //考试日期
      examTimeList: [],  //考试时间
      statusItem: [
        { name: '全部状态', value: '' },
        { name: '考试中', value: 'normal' },
        { name: '未考试', value: 'miss' },
        { name: '已取号', value: 'tookNumber' },
        { name: '已考试', value: 'submitted' },
      ],
      addressItem: [
        { examAddressName: '全部考试场地', id: '' }
      ],
      statusObj:{
        normal: '考试中',
        miss: '未考试',
        tookNumber: '已取号',
        submitted: '已考试',
      },
      associationAuthority: false,
    }
  },
  watch: {
    'filtrate.appraisalId':{
      handler: function() {
        if(!this.filtrate.appraisalId){
          this.subjectList = [{'name': '全部科目', 'value': ''}]
          this.filtrate.subject = ''
          return false
        }
        let subjectList = this.batchList.filter(element => element.id === this.filtrate.appraisalId)[0].subject
        subjectList.forEach(element => {
          element.value = element.name
        })
        this.subjectList = [{'name': '全部科目', 'value': ''}]
        this.subjectList = this.subjectList.concat(subjectList)
        this.getExamTime()
      }
    },
    'filtrate.subject': {
      handler: function() {
        this.getExamTime()
      }
    },

    'filtrate.day': {
      handler: function() {
        if(this.filtrate.day.length){
          this.filtrate.period = []
        }
        let list = []
        this.filtrate.day.forEach(element => {
          if(element){
            list.push(this.examDateList.filter(childElement => childElement.label === element)[0]) 
          }
        })
        let timeList = []
        list.forEach(element => {
          element.children.forEach(childElement => {
            if(!timeList.includes(childElement)){
              timeList.push(childElement)
            }
          })
        })
        this.examTimeList = []
        timeList.forEach(element => {
          this.examTimeList.push({
            'name': element,
            'value': element
          })
        })
      },
      deep: true
    },
    filtrate: {
      handler: function() {
        this.page = 1
        this.getPageList()
      },
      deep: true
    }
  },
  created() {
    this.getExamAddress()
    this.getBatchList() 
  },
  computed: {
    pageCount: function() {
      return this.listCount % this.limit === 0 ? parseInt(this.listCount / this.limit) : parseInt(this.listCount / this.limit) + 1
    },
  },
  methods: {
    getExamAddress: function() { //查询考点信息
      this.$http.get('/ExamAddress/ShowAll').then(res => {
        if(res.data.data){
          this.addressItem = this.addressItem.concat(res.data.data.list)
        }
      })
    },
    getBatchList: function() { //查询现有批次信息
      this.$http.get('/examination/batch/list').then(res => {
        if(res.data.data){
          this.batchList = res.data.data
          this.filtrate.appraisalId = this.batchList.find(element => element.occupationLevelCode === 'sk-003' ).id
          this.batchList.unshift({'name': '全部批次', 'vlaue': ''})
          this.getPageList()
        }
      })
    },
    getExamTime: function() {
      let params = {
        appraisalId: this.filtrate.appraisalId,
        subject: this.filtrate.subject
      }
      console.log(params)
      this.$http.get('/examination/day/list', { params }).then(res => {
        if(res.data.success){
          this.examDateList = res.data.data
          this.formatDayList(res.data.data)
        }
      })
    },
    getPageList: function() { //获取列表数据
      let params = {
        ...this.filtrate,
        page: this.page,
        limit: this.limit
      }
      params.day = params.day.join(',')
      params.period = params.period.join(',')
      this.$http.get(`/exam/room/list`, { params }).then((res) => {
        if (res.data.success) {
          this.listCount = res.data.data.count 
          let list = res.data.data.info || []
          if(res.data.data.info){
            list.forEach((element,index) => {
              element.serial = (this.page - 1 ) * this.limit + ( index + 1)
              element.examDate = element.day + ' ' + element.period
              element.subjectText = element.subject === 'theory' ? '理论' : '实操'
              element.occupationLevelCodeText = this.batchList.filter(ele => ele.occupationLevelCode === element.levelCode)[0].occupationLevel
              element.alreadyNumber = element.maxNumber - element.remainNumber
              element.latestSignUpTimeText = element.latestSignUpTime ? this.$moment(element.latestSignUpTime).format('YYYY-MM-DD HH:mm:ss') : ''
            })
          }
          this.examarr = list
        }
      })
    },
    formatDayList: function(dayArray) {
      let examDayList = []
      dayArray.forEach(element => {
        examDayList.push({
          'name': element.label,
          'value': element.label
        })
      })
      this.examDayList = []
      this.examDayList = this.examDayList.concat(examDayList)
    },
    formatTimeList: function(timeArray) {
    },
    studentInfoPreview: function(id) { //查看考生信息
      this.$router.push(`/batchSignUp/preview/${id}/preview`)
    },
    studentInfoReview: function(id) {
      this.$router.push(`/batchSignUp/review/${id}/review`)
    },
    associationItem: function(id) {
      this.$alert('确定要撤销该考生的考试吗？撤销后该考生将不能参加考试', '提示', {
        confirmButtonText: '确定',
        showCancelButton: '取消',
        center: true,
        callback: action => {
          if(action === 'confirm'){
            let params = {
              id
            }
            this.$http.delete('/examination/cancel', {params}).then(res => {
              if(res.data.success){
                this.$message({
                  type: 'success',
                  message: '撤销成功'
                })
              }else {
                this.$message({
                  type: 'error',
                  message: res.data.msg || '撤销失败'
                })
              }
              setTimeout(()=>{
                this.getPageList()
              }, 300)
            })
          }
        }
      })
    },
    exportExcel: function() {
      let params = {
        appraisalId: this.filtrate.appraisalId,
        subject: this.filtrate.subject,
        day: this.filtrate.day,
        period: this.filtrate.period
      }
      params.day = params.day.join(',')
      params.period = params.period.join(',')
      this.$http.post('/examFile/export/time', params, {responseType: 'blob'}).then(res => {
        if(res.data){
          downloadBlob(res.data, decodeURIComponent(res.headers.filename))
        }
      }).catch(()=>{
        this.$message({
          type: 'error',
          message: '导出失败'
        })
      })
    },
    handleSizeChange(val) {
      this.page = 1
      this.limit = val
      this.getPageList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getPageList()
    },
    handleSelectionChange(val) {  //多选方法
      this.multipleSelection = val;
    },
    getRowKeys(row) {
      return row.id + row.serial;
    },
  }
}
</script>

<style lang="less" scoped>
.exam_contain {
  min-width: 1920px;
  box-sizing: border-box;
}
.exam_contain {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: @whitee;
  width: 100%;
  padding: 30px;
  overflow: auto;
  height: 100vh;
}
.exam_button_box {
  display: flex;
  justify-content: flex-end;
  margin: 40px 0;
}
.exam_button_box button {
  width: 200px;
  height: 80px;
  margin: 0 20px 0 0;
}
.page_footer{
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  .van-pagination{
    margin: 0 20px;
  }
}
.operation_img {
  width: 25PX !important;
  height: 25PX !important;
  display: block;
  margin: 0 3PX
}
.exam_select_flex {
  display: flex;
  flex-direction: column;
  margin-left: 40PX;
}
.exam_select_box{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-top: 50px;
}
.exam_select_item{
  white-space: nowrap;
  display: flex;
  align-items: center;
  margin-right: 320px;

}
.table_wrapper {
  flex: 1;
  width: 100%;
  margin: 0;
  height: 650PX;
  position: relative;
  .table_content {
    position: absolute;
    width: 100%;
    margin: 0;
    .table_content_operation{
      display: flex;
      justify-content: center;
    }
  }
}
/deep/ .has-gutter{
  color: black;
}
/deep/ .cell {
  text-align: center;
  padding: 0 10px !important;
}
/deep/ .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell{
  background: #F0F5FA;
}
</style> 
